import { useRef } from 'react';
import { SimpleGraphView } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphView';
import { createGraphInterface } from 'viewpointBuilder/components/SimpleGraph/GraphInterface';
import { SimpleGraphContainerWithGreyBackground } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphViewContainer';
import { MetaInfoPanelProps, MetaInfoPanel } from './MetaInfoPanel';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { ResizablePageBody } from '@ardoq/page-layout';
import {
  CollapsibleGraphGroup,
  MetamodelViewGraphEdge,
  MetaModelViewGraphNode,
} from '@ardoq/graph';
import type { I18nLocale } from '@ardoq/i18n';

type MetaInfoContentProps = MetaInfoPanelProps & {
  closeViewpointBuilder: () => void;
  primaryButtonConfig: PrimaryButtonConfig;
  label: string;
  graphData: {
    graphNodes: Map<string, MetaModelViewGraphNode>;
    graphEdges: Map<string, MetamodelViewGraphEdge>;
    graphGroups: Map<string, CollapsibleGraphGroup>;
  };
  i18nLocale: I18nLocale;
};

export const MetaInfoContent = ({
  state,
  commands,
  closeViewpointBuilder,
  generateViewpointDescription,
  primaryButtonConfig,
  label,
  graphData,
  paths,
  i18nLocale,
}: MetaInfoContentProps) => {
  const graphInterface = useRef(createGraphInterface());

  const { graphNodes, graphEdges, graphGroups } = graphData;
  return (
    <ResizablePageBody
      skipPadding
      footerContent={
        <ViewpointBuilderFooter
          closeViewpointBuilder={closeViewpointBuilder}
          primaryButtonConfig={primaryButtonConfig}
          i18nLocale={i18nLocale}
        />
      }
      rightContentInitialWidth={600}
      rightContent={
        <MetaInfoPanel
          state={state}
          commands={commands}
          generateViewpointDescription={generateViewpointDescription}
          paths={paths}
          i18nLocale={i18nLocale}
        />
      }
    >
      <SimpleGraphContainerWithGreyBackground>
        <SimpleGraphView
          viewModel={{ graphNodes, graphEdges, graphGroups }}
          graphInterface={graphInterface.current}
          label={label}
        />
      </SimpleGraphContainerWithGreyBackground>
    </ResizablePageBody>
  );
};
